/* ==========================================================================
   TwoStrong PDP behaviour — offer selection, accordions, notify-me.

   Loaded with `defer` from sections/section-twostrong-pdp.liquid, so it runs
   after the footer's jQuery/magnificPopup are in place.

   Vanilla apart from the popup: magnificPopup is a jQuery plugin, so that one
   path checks for jQuery and degrades to a link if it is missing. Everything
   else works with no dependency.
   ========================================================================== */
(function () {
    'use strict';

    var root = document.getElementById('tsPdp');
    if (!root) return;

    /* ---------------------------------------------------------------------
       1. Offer cards. Presentational — nothing is added to a cart — but the
          selection still has to behave like a radio group for keyboard and
          screen-reader users.
       --------------------------------------------------------------------- */
    var offers = root.querySelectorAll('[data-ts-offer]');

    function selectOffer(chosen) {
        Array.prototype.forEach.call(offers, function (offer) {
            var on = offer === chosen;
            offer.classList.toggle('is-selected', on);
            offer.setAttribute('aria-checked', on ? 'true' : 'false');
            offer.setAttribute('tabindex', on ? '0' : '-1');
        });
    }

    Array.prototype.forEach.call(offers, function (offer) {
        offer.addEventListener('click', function () { selectOffer(offer); });
        offer.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                selectOffer(offer);
                return;
            }
            /* Arrow keys move between radios, per the radiogroup pattern. */
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight' ||
                e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                e.preventDefault();
                var list = Array.prototype.slice.call(offers);
                var i = list.indexOf(offer);
                var step = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
                var next = list[(i + step + list.length) % list.length];
                selectOffer(next);
                next.focus();
            }
        });
    });

    /* ---------------------------------------------------------------------
       2. Accordions. One handler covers both the buy-box details and the FAQ
          list; they differ only in class names, which are passed in.
       --------------------------------------------------------------------- */
    function wireAccordion(itemSelector, headSelector) {
        var items = root.querySelectorAll(itemSelector);

        Array.prototype.forEach.call(items, function (item) {
            var head = item.querySelector(headSelector);
            var panel = item.querySelector('[data-ts-panel]');
            if (!head) return;

            /* Reflect the Liquid-rendered starting state onto ARIA before any
               click, so the first render is announced correctly too. */
            var open = item.classList.contains('is-open');
            head.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (panel) panel.hidden = false;

            head.addEventListener('click', function () {
                var nowOpen = !item.classList.contains('is-open');

                /* One panel at a time, matching the design's single open row. */
                Array.prototype.forEach.call(items, function (other) {
                    if (other === item) return;
                    other.classList.remove('is-open');
                    var otherHead = other.querySelector(headSelector);
                    if (otherHead) otherHead.setAttribute('aria-expanded', 'false');
                });

                item.classList.toggle('is-open', nowOpen);
                head.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
            });
        });
    }

    wireAccordion('.ts-accordion__item', '.ts-accordion__head');
    wireAccordion('.ts-faq__item', '.ts-faq__head-btn');

    /* ---------------------------------------------------------------------
       3. Add to cart -> Klaviyo notify-me.

          TwoStrong is out of stock and has no selling plan, so there is nothing
          to add. The button opens the popup that snippets/fon-klaviyo-force-oos
          .liquid renders at the end of layout/theme.liquid.

          Three things have to be true for that to work: the popup div is on the
          page, jQuery is loaded, and magnificPopup is registered on it. All
          three are unconditional in this theme, so the fallback below only ever
          runs if someone re-disables the popup — and it only navigates when a
          data-ts-fallback is actually set, which it is not here, because the
          only sensible target would be this same page.
       --------------------------------------------------------------------- */
    var notifyButtons = root.querySelectorAll('.js-twostrong-notify');

    Array.prototype.forEach.call(notifyButtons, function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();

            var target = btn.getAttribute('data-ts-popup');
            var popup = target ? document.querySelector(target) : null;
            var $ = window.jQuery;

            if (popup && $ && $.magnificPopup) {
                /* THE FORM NEEDS KLAVIYO (2026-10-15, Renz: "popup not
                   working" on /products/twostrong). layout/theme.liquid loads
                   Klaviyo on the first scroll or touchmove, and this button
                   sits in the hero, so a click before any scroll opened the
                   popup with its embed (klaviyo-form-RyAWKc) still empty. Load
                   it now if it is not on the page yet -- the same guard as the
                   nav's opener (fon-inline-klaviyo-oos.js) and v88-buybox.js. */
                if (!document.querySelector('script[src^="https://static.klaviyo.com/onsite/js/"]')) {
                    var k = document.createElement('script');
                    k.src = 'https://static.klaviyo.com/onsite/js/YnKpzp/klaviyo.js?company_id=YnKpzp';
                    k.async = true;
                    document.head.appendChild(k);
                }
                $.magnificPopup.open({
                    items: { src: target },
                    type: 'inline',
                    /* Em's note: the page scrolled behind the popup. Lock the
                       document while it is open. */
                    callbacks: {
                        open:  function () { document.documentElement.classList.add('ts-modal-lock'); },
                        close: function () { document.documentElement.classList.remove('ts-modal-lock'); }
                    }
                });
                return;
            }

            var fallback = btn.getAttribute('data-ts-fallback');
            if (fallback) window.location.href = fallback;
        });
    });
})();
